import { createElement, lazy } from "react"
import { AppRouteConfig } from "@/types/navigation"
import { ROUTES } from "./path"

const IntegrationList = lazy(() => import("@/pages/dashboard/integration/list"))
const AddIntegration = lazy(() => import("@/pages/dashboard/integration/add"))
const SlackCallback = lazy(() => import("@/pages/dashboard/integration/slack-callback"))
const ManageIntegration = lazy(() => import("@/pages/dashboard/integration/manage"))

export const integrationRoutes: AppRouteConfig[] = [
  {
    path: ROUTES.DASHBOARD.INTEGRATIONS.INDEX,
    element: createElement(IntegrationList),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
  {
    path: ROUTES.DASHBOARD.INTEGRATIONS.ADD,
    element: createElement(AddIntegration),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
  {
    path: ROUTES.DASHBOARD.INTEGRATIONS.SLACK_CALLBACK,
    element: createElement(SlackCallback),
    restricted: true,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.DASHBOARD.INTEGRATIONS.MANAGE(":id"),
    element: createElement(ManageIntegration),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
]
